/*eslint-disable */
import app_header from '../components/header/index.vue';
 

export default {
  name: 'app',
  components: {
    'app-header': app_header 
  },
  props: [],
  data () {
    return {
       
    }
  },
  computed: {

  }, 
  methods: {

  }
}
